import type { UpdateSaunaConfigPayload } from '@jums-dashboard/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { updateSaunaConfig } from '../services/saunaService';
import { saunaQueryKey } from './useSauna';

export default function useUpdateSaunaConfig() {
  const qc = useQueryClient();
  return useMutation<{ ok: true }, Error, UpdateSaunaConfigPayload>({
    mutationFn: (payload) => updateSaunaConfig(payload),
    onSuccess: (_data, { homeId }) => {
      toast.success('Sauna configuration saved.');
      void qc.invalidateQueries({ queryKey: saunaQueryKey(homeId) });
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to save sauna configuration.');
    },
  });
}
